"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workspaceAdminSkin = void 0;
var qs = require("qs");
exports.workspaceAdminSkin = function (axios) {
    return {
        postSkinsContainersContainerNoTree: function (request) {
            var containerNo = request.pathParams.containerNo;
            var query = qs.stringify(request.params);
            return axios.post("/skins/containers/" + containerNo + "/tree?" + query, request.data);
        },
    };
};
